export const formatOrchidProTypeOrder = (typeIndex) => {
  switch (typeIndex) {
    case 0:
      return "Primary Professional Type";
    case 1:
      return "Secondary Professional Type (optional)";
    case 2:
      return "Third Professional Type (optional)";
    default:
      return "Professional Type";
  }
};
